import {Component, OnDestroy, OnInit} from '@angular/core';
import {NavigationEnd, NavigationStart, Router} from "@angular/router";
import {AuthenticationService} from "./modules/auth/_services/authentication.service";
import {PopupComponent} from "./shared/popup/popup.component";
import {fromEvent} from "rxjs";
import {AppVersionService} from './service/app-version/appVersion.service';
import NoSleep from 'nosleep.js'
import {RouterPaths} from "./config/router-paths.model";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    login = false;
    isConnected = true;
    noInternetConnection = false;
    noSleep;

    constructor(private router: Router,
                private authenticationService: AuthenticationService,
                private popupComponent: PopupComponent,
                private appVersionService: AppVersionService) {
        fromEvent(window, 'online').subscribe((resp: any) => {
            this.isConnected = true;
            this.noInternetConnection = false;
            this.popupComponent.closePopup();
        });

        fromEvent(window, 'offline').subscribe((resp: any) => {
            this.isConnected = false;
            this.noInternetConnection = true;
            const text = 'No Internet Connection: please, try to connect to the Internet';
            this.popupComponent.showPopupError({text: text, closeBtn: false})
        });

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
              const arrow = document.querySelector('.footer__scroll-btn');
              if (arrow) {
                //arrow.classList.remove('is-active');
                arrow.classList.add('no-transform');
              }
            }
            if (event instanceof NavigationEnd) {
                if (!event.url.includes(RouterPaths.settings)) {
                    if (document.querySelector('.main__inner')) {
                        document.querySelector('.main__inner').scroll({
                            top: 0,
                            behavior: "smooth"
                        })
                    }
                }
                setTimeout(() => {
                  const arrow = document.querySelector('.footer__scroll-btn');
                  const scrolledBlock = document.querySelector('.main__inner');
                  if (arrow && scrolledBlock) {
                    const scrollTop = scrolledBlock.scrollTop;
                    const scrollHeight = scrolledBlock.scrollHeight;
                    const clientHeight = scrolledBlock.clientHeight;
                    if (scrollTop + clientHeight >= scrollHeight) {
                      arrow.classList.remove('is-active');
                    } else {
                      arrow.classList.add('is-active');
                    }
                  }
                }, 500);
                this.appHeight();
            }
        });
    }

    ngOnInit() {
        if (this.isIos()) {
            document.body.classList.add('is-ios');
        }

        window.addEventListener('resize', this.appHeight);
        window.addEventListener('orientationchange', this.appHeight);
        this.appHeight();

        this.refreshToken();
        this.appVersion();

        this.setNoScreenLock();
    }

    ngOnDestroy() {}

    appVersion(){
        this.appVersionService.checkVersion();
    }

    refreshToken() {
        this.authenticationService.refreshToken();
    }

    isIos(){
        let userAgent = window.navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod/.test( userAgent );
    }

    appHeight() {
        setTimeout(() => {
            const doc = document.documentElement;
            doc.style.setProperty('--app-height', `${window.innerHeight}px`);
            doc.style.setProperty('--app-width', `${window.innerWidth}px`);
        }, 0);
    }

    setNoScreenLock() {
        this.noSleep = new NoSleep();
        const $this = this;
        document.addEventListener('click', function enableNoSleep() {
            document.removeEventListener('click', enableNoSleep, false);
            $this.noSleep.enable(); // on
            // $this.noSleep.disable(); off
        }, false);
    }
}
